<div class="mx-4 mb-5 w-fit rounded-2xl border border-gray-300 bg-gradient-to-r from-gray-50 to-white px-5 py-3 sm:mx-5">
  <div class="border-l-4 border-gray-800 pl-4">
    <p class="text-xs font-semibold uppercase tracking-[0.18em] text-gray-500">
      Manage Application Section
    </p>
    <h2 class="mt-1 text-2xl font-bold tracking-tight text-gray-900">
      Users
    </h2>
  </div>
</div>

<app-manage-application-nav></app-manage-application-nav>

<ng-template #loading>
  <div class="fixed inset-0 z-50 flex items-center justify-center bg-white/60 backdrop-blur-sm">
    <div class="flex flex-col items-center gap-4 rounded-2xl border border-gray-300 bg-white px-8 py-6">
      <div class="h-10 w-10 animate-spin rounded-full border-4 border-gray-300 border-t-gray-700"></div>
      <p class="text-sm font-medium text-gray-500">
        Loading users...
      </p>
    </div>
  </div>
</ng-template>

<ng-container *ngIf="hasLoaded; else loading">
  <main class="mt-5 px-4 sm:px-5">

    <!-- TOOLBAR: ADD + SEARCH + PAGINATOR -->
    <section class="mb-5">
      <div class="grid grid-cols-12 items-center gap-4 rounded-2xl border border-gray-300 bg-white/95 p-4 backdrop-blur">

        <!-- ADD BUTTON -->
        <div class="col-span-12 md:col-span-3 lg:col-span-3">
          <button
            class="primary-btn h-[50px] rounded-xl px-5 text-sm font-semibold transition"
            (click)="addNewUser()"
          >
            Add New User
          </button>
        </div>

        <!-- SEARCH + PAGINATOR -->
        <div class="col-span-12 md:col-span-9 lg:col-span-9">
          <div class="flex flex-col items-stretch gap-3 xl:flex-row xl:items-center xl:justify-end">

            <!-- SEARCH -->
            <div class="flex w-full justify-center">
              <div class="flex h-[50px] w-full max-w-md items-center rounded-xl border border-gray-300 bg-gray-50 px-3 transition focus-within:border-gray-300 focus-within:bg-white">

                <mat-icon class="flex-shrink-0 text-gray-400">
                  search
                </mat-icon>

                <input
                  #searchInput
                  type="text"
                  placeholder="Search..."
                  (keyup.enter)="onSearchSubmit(searchInput.value)"
                  (input)="searchValue = searchInput.value"
                  [(ngModel)]="searchValue"
                  class="min-w-0 flex-grow bg-transparent px-2 text-sm text-gray-700 outline-none placeholder-gray-400"
                />

                <button
                  type="button"
                  (click)="clearSearch(); searchInput.value=''; searchValue=''"
                  [class.opacity-0]="!searchValue"
                  [class.pointer-events-none]="!searchValue"
                  class="ml-1 flex flex-shrink-0 items-center justify-center rounded-full p-1.5 text-gray-500 transition hover:bg-gray-100 hover:text-gray-700"
                >
                  <mat-icon class="cursor-pointer text-lg">
                    close
                  </mat-icon>
                </button>
              </div>
            </div>

            <!-- PAGINATOR -->
            <div class="flex shrink-0 items-center justify-center xl:justify-end">
              <div class="w-fit overflow-hidden rounded-xl bg-white">
                <mat-paginator
                  [length]="totalItems"
                  [pageSize]="pageSize"
                  [pageIndex]="currentPage - 1"
                  [pageSizeOptions]="[pageSize]"
                  showFirstLastButtons
                  (page)="onPageChange($event)"
                >
                </mat-paginator>
              </div>
            </div>

          </div>
        </div>

      </div>
    </section>

    <!-- USERS TABLE -->
    <section class="grid grid-cols-1 gap-4">
      <div class="col-span-1 overflow-hidden rounded-2xl border border-gray-300 bg-white">
        <div class="w-full overflow-x-auto">
          <mat-table
            [dataSource]="dataSource"
            matSort
            (matSortChange)="onSortChange($event)"
            class="!inline-table !w-full min-w-[980px] table-fixed table-alternate text-sm"
          >

            <!-- ID COLUMN -->
            <ng-container matColumnDef="ID">
              <th
                mat-header-cell
                *matHeaderCellDef
                mat-sort-header
                class="w-[120px] whitespace-nowrap bg-gray-50 px-5 py-4 text-left text-xs font-semibold uppercase tracking-[0.14em] text-gray-500"
              >
                ID
              </th>
              <td
                mat-cell
                *matCellDef="let user"
                class="w-[120px] whitespace-nowrap px-5 py-5 text-sm font-medium text-gray-800"
              >
                #{{ user.ID }}
              </td>
            </ng-container>

            <!-- NAME COLUMN -->
            <ng-container matColumnDef="name">
              <th
                mat-header-cell
                *matHeaderCellDef
                mat-sort-header
                class="w-[150px] whitespace-nowrap bg-gray-50 px-5 py-4 text-left text-xs font-semibold uppercase tracking-[0.14em] text-gray-500"
              >
                Name
              </th>
              <td
                mat-cell
                *matCellDef="let user"
                class="w-[150px] px-5 py-5 text-sm font-medium text-gray-900"
              >
                {{ user.FirstName || '' | titlecase }} {{ user.LastName || '' | titlecase }}
              </td>
            </ng-container>

            <!-- EMAIL COLUMN -->
            <ng-container matColumnDef="email">
              <th
                mat-header-cell
                *matHeaderCellDef
                mat-sort-header
                class="w-[200px] whitespace-nowrap bg-gray-50 px-5 py-4 text-left text-xs font-semibold uppercase tracking-[0.14em] text-gray-500"
              >
                Email
              </th>
              <td
                mat-cell
                *matCellDef="let user"
                class="w-[200px] px-5 py-5 text-sm text-gray-700"
              >
                {{ user.Email }}
              </td>
            </ng-container>

            <!-- ROLE COLUMN -->
            <ng-container matColumnDef="role">
              <th
                mat-header-cell
                *matHeaderCellDef
                mat-sort-header
                class="w-[120px] whitespace-nowrap bg-gray-50 px-5 py-4 text-left text-xs font-semibold uppercase tracking-[0.14em] text-gray-500"
              >
                Role
              </th>
              <td
                mat-cell
                *matCellDef="let user"
                class="w-[120px] whitespace-nowrap px-5 py-5"
              >
                <span
                  class="inline-flex w-[120px] items-center justify-center rounded-full px-3 py-1.5 text-xs font-semibold"
                  [ngClass]="{
                    'bg-blue-100 text-blue-800': user.user_group?.Name === 'Admin',
                    'bg-green-100 text-green-800': user.user_group?.Name === 'ContentUser',
                    'bg-purple-100 text-purple-800': user.user_group?.Name === 'Billing',
                    'bg-gray-200 text-gray-800': !user.user_group?.Name || user.user_group?.Name === 'N/A'
                  }"
                >
                  {{ user.user_group?.Name || 'N/A' }}
                </span>
              </td>
            </ng-container>

            

            <!-- STATUS COLUMN -->
            <ng-container matColumnDef="status">
              <th
                mat-header-cell
                *matHeaderCellDef
                mat-sort-header
                class="w-[120px] whitespace-nowrap bg-gray-50 px-5 py-4 text-left text-xs font-semibold uppercase tracking-[0.14em] text-gray-500"
              >
                Status
              </th>
              <td
                mat-cell
                *matCellDef="let user"
                class="w-[120px] whitespace-nowrap px-5 py-5"
              >
                <span
                  class="inline-flex w-[90px] items-center justify-center rounded-full px-3 py-1.5 text-xs font-semibold"
                  [ngClass]="{
                    'bg-green-100 text-green-800': user.isActive === 1,
                    'bg-red-100 text-red-800': user.isActive === 0
                  }"
                >
                  {{ user.isActive ? 'Active' : 'Inactive' }}
                </span>
              </td>
            </ng-container>

            <!-- CREATED AT COLUMN -->
            <ng-container matColumnDef="created_at">
              <th
                mat-header-cell
                *matHeaderCellDef
                mat-sort-header
                class="w-[170px] whitespace-nowrap bg-gray-50 px-5 py-4 text-left text-xs font-semibold uppercase tracking-[0.14em] text-gray-500"
              >
                Created At
              </th>
              <td
                mat-cell
                *matCellDef="let user"
                class="w-[170px] whitespace-nowrap px-5 py-5 text-sm text-gray-600"
              >
                {{ user.created_at | date:'dd/MM/yyyy HH:mm' }}
              </td>
            </ng-container>

            <!-- ACTIONS COLUMN -->
            <ng-container matColumnDef="actions">
              <th
                mat-header-cell
                *matHeaderCellDef
                class="w-[150px] whitespace-nowrap bg-gray-50 px-5 py-4 text-center text-xs font-semibold uppercase tracking-[0.14em] text-gray-500"
              >
                Actions
              </th>
              <td
                mat-cell
                *matCellDef="let user"
                class="w-[150px] whitespace-nowrap px-5 py-5"
              >
                <div class="flex w-full items-center justify-center gap-1">
                  <button
                    mat-icon-button
                    class="cursor-pointer text-gray-600 transition-colors hover:text-blue-600"
                    (click)="editUser(user)"
                  >
                    <mat-icon>edit</mat-icon>
                  </button>

                  <button
                    mat-icon-button
                    class="cursor-pointer text-gray-600 transition-colors hover:text-red-600"
                    (click)="openDeleteConfirm(user)"
                  >
                    <mat-icon>delete</mat-icon>
                  </button>
                </div>
              </td>
            </ng-container>

            <!-- HEADER AND ROW DEFINITIONS -->
            <tr
              mat-header-row
              *matHeaderRowDef="displayedColumns"
              class="border-b border-gray-300 bg-gray-50"
            ></tr>

            <tr
              mat-row
              *matRowDef="let row; columns: displayedColumns;"
              class="border-b border-gray-100 bg-white transition-colors even:bg-gray-50/40 hover:bg-gray-100"
            ></tr>

          </mat-table>
        </div>
      </div>

      <div
        *ngIf="dataSource.data.length > 0"
        class="col-span-1 flex items-center justify-end gap-2 rounded-2xl bg-white px-3 py-2"
      >
        <div class="w-fit overflow-hidden rounded-xl bg-white">
          <mat-paginator
            [length]="totalItems"
            [pageSize]="pageSize"
            [pageIndex]="currentPage - 1"
            [pageSizeOptions]="[pageSize]"
            showFirstLastButtons
            (page)="onPageChange($event)"
          >
          </mat-paginator>
        </div>
      </div>
    </section>
  </main>
</ng-container>

<!-- TEMPLATES -->
<ng-template #userFormTmpl>
  <app-user-form
    [formData]="selectedUser"
    (onSubmitClbk)="onSubmitUserClbk()"
  >
  </app-user-form>
</ng-template>

<ng-template #confirmDeleteTmpl>
  <div class="flex flex-col gap-4 p-4">
    <p>
      Are you sure you want to delete user
      <b>{{ selectedUser.FirstName }} {{ selectedUser.LastName }}</b>?
    </p>

    <div class="flex flex-row items-center justify-center gap-2">
      <button
        class="base-btn rounded bg-red-600 px-4 py-2 text-white"
        (click)="deleteUser()"
      >
        Confirm
      </button>

      <button
        class="base-btn rounded bg-gray-300 px-4 py-2 text-gray-800"
        (click)="dialog.closeAll()"
      >
        Cancel
      </button>
    </div>
  </div>
</ng-template>